import React from 'react';
import SEOHead from '../components/SEOHead';
import './FAQ.css';

const FAQ = () => {
  const faqItems = [
    {
      question: "What is OneTimer?",
      answer: "OneTimer is a simple timer app designed to help you track focused time on your passions or obsessions. It's perfect for anyone who wants to build consistent habits and see their progress over time."
    },
    {
      question: "Who is OneTimer designed for?",
      answer: "OneTimer is primarily targeted at users aged 16-30 who want to develop focused work habits and track their progress on personal projects or skills."
    },
    {
      question: "Is my data safe and private?",
      answer: "Absolutely! OneTimer stores all your timer data, progress statistics, and information locally on your device. We don't collect, store, or share any personal information. Your data stays on your device and is only accessible to you."
    },
    {
      question: "What kind of data does OneTimer track?",
      answer: "The app tracks your timer sessions, daily totals, averages, and displays heatmaps of your progress. All of this data is stored locally on your device using asynchronous storage."
    },
    {
      question: "What happens if I delete the app?",
      answer: "Since all data is stored locally on your device, if you delete the app or clear your device storage, your timer data may be lost. We recommend backing up important progress before making changes to your device."
    },
    {
      question: "How can I get support?",
      answer: "If you have questions or need help with OneTimer, you can contact me at theonetimerapp@gmail.com or visit our contact page."
    }
  ];

  return (
    <>
      <SEOHead
        title="FAQ - OneTimer App Questions & Answers"
        description="Everything you need to know about OneTimer. Find answers about privacy, data storage, premium features, and more."
        keywords="OneTimer FAQ, timer app questions, privacy policy, data storage, productivity app"
        path="/faq"
      />
      <div className="faq-container">
      <div className="faq-header">
        <h1>FAQ</h1>
        <p className="subtitle">Everything you need to know about OneTimer</p>
      </div>
      
      <div className="faq-content">
        {faqItems.map((item, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question">{item.question}</div>
            <div className="faq-answer">{item.answer}</div>
          </div>
        ))}
      </div>
      </div>
    </>
  );
};

export default FAQ;